var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-search-section-news",attrs:{"id":_vm.id}},[_c('div',{class:[
			'grid gap-layout-gutter',
			'grid-cols-1 >=768:grid-cols-2 >=1024:grid-cols-3',
		]},_vm._l((_vm.items),function(item,index){return _c('ContentCard',{key:`news-${index}`,attrs:{"title":item.title || item.name,"teaser":item.teaser,"link":{ url: item.url, target: item.target },"image":{
				...(item.image || {}),
				aspectRatio: 416 / 234,
			},"has-external-outbound-redirect":item.hasExternalOutboundRedirect,"external-outbound-redirect":item.externalOutboundRedirect},scopedSlots:_vm._u([{key:"before",fn:function(){return [_c('div',{staticClass:"font-darker-grotesque font-semibold mb-6",domProps:{"textContent":_vm._s(_vm.formatDate(item.newsDate))}})]},proxy:true}],null,true)})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }